export const PRICES = {
  FIRST_INDOOR: 21000,
  EXTRA_INDOOR: 15000,
  OUTDOOR: 4000,
  OUTDOOR_HIGH: 6500,
  TRAVEL_FEE: 5000,
};

export function formatFt(n) {
  return `${n.toLocaleString("hu-HU")} Ft`;
}

export function computePrice({ indoor, outdoor, high, far }) {
  const items = [];
  if (indoor >= 1) items.push({ key: "firstIndoor", qty: 1, sum: PRICES.FIRST_INDOOR });
  if (indoor > 1) items.push({ key: "extraIndoor", qty: indoor - 1, sum: (indoor - 1) * PRICES.EXTRA_INDOOR });
  const std = Math.max(outdoor - high, 0);
  if (std > 0) items.push({ key: "outdoorStd", qty: std, sum: std * PRICES.OUTDOOR });
  if (high > 0) items.push({ key: "outdoorHigh", qty: high, sum: high * PRICES.OUTDOOR_HIGH });
  if (far) items.push({ key: "travel", qty: 1, sum: PRICES.TRAVEL_FEE });
  return { items, total: items.reduce((a, i) => a + i.sum, 0) };
}
